// LF360-1815. Pure normaliser for the scenario-response criterion's
// "over the last N answers" window (the criterion's `period`). Extracted so it
// is unit-testable in this repo's DOM-free jest env (no jsdom), mirroring
// lastNTaskWindow.ts. Mirrors the truncate+clamp used by the adherence window.
export const DEFAULT_ANSWERS_WINDOW = 1;

/** Truncate to an integer and clamp to >= 1; fall back to 1 on non-finite input. */
export function clampAnswersWindow(raw: string | number): number {
  const parsed = Math.trunc(Number(raw));
  return Number.isFinite(parsed) && parsed >= 1 ? parsed : DEFAULT_ANSWERS_WINDOW;
}
